import "@/App.css";
import { HashRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Portfolio } from "./components/Portfolio";
import { About } from "./components/About";
import { Services } from "./components/Services";
import { Booking } from "./components/Booking";
import { Reviews } from "./components/Reviews";
import { Footer } from "./components/Footer";

const Home = () => {
    return (
        <div className="bg-black text-white smooth-scroll">
            <Navbar />
            <main>
                <Hero />
                <Portfolio />
                <About />
                <Services />
                <Reviews />
                <Booking />
            </main>
            <Footer />
        </div>
    );
};

function App() {
    return (
        <div className="App">
            <HashRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                </Routes>
            </HashRouter>
            <Toaster
                position="bottom-right"
                theme="dark"
                toastOptions={{
                    style: {
                        background: "#0a0a0a",
                        border: "1px solid #27272a",
                        color: "#fff",
                        borderRadius: 0,
                    },
                }}
            />
        </div>
    );
}

export default App;
